import React from 'react';

export default function FeedbackBanner({ feedbackUrl }) {
  return (
    <div style={{background:'#6c63ff',color:'#fff',textAlign:'center',padding:'0.75rem 1rem',fontSize:'1.0rem',fontFamily:'Inter,sans-serif',letterSpacing:'0.01em'}}>
      ⭐ Vector Tuner is in beta 🚀 -
      <a href={feedbackUrl} target="_blank" rel="noopener" style={{color:'#fff',textDecoration:'underline',fontWeight:500}}> Give Feedback 💬</a>
    </div>
  );
} 